import { render, staticRenderFns } from "./user-info-status.vue?vue&type=template&id=46ae1a5c&"
import script from "./user-info-status.vue?vue&type=script&lang=js&"
export * from "./user-info-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports